import React, { Component } from 'react';
import Link from "./link";

class List extends Component {
  render() {
    const level = this.props.level + 1;
    // Submenu links
    let linkStyles={ lineHeight:"1.5em" };
    // Primary links
    if (this.props.className.indexOf("panel")) {
      linkStyles={border:"0 solid #ccc",borderTopWidth:"1px",}
    }
    // Second main menu
    let listStyles = this.props.styles;
    if (this.props.className[this.props.className.length - 1] === "1") {
      listStyles.backgroundColor="#ccc";
    }
    return (
      <ul className={this.props.className} style={listStyles} >
        {this.props.links.map((link, i) => (
          <Link className={'menuLevel' + level} level={level} key={i} link={link} showMenu={this.props.showMenu}
            styles={{
              ...linkStyles,
              padding:level>1?"8px":"16px",
              paddingLeft:level>2?"56px":level>1?"36px":"16px",
            }} />
        ))}
      </ul>
    );
  }
}

export default List;
